interface UploadApiResponse {
  file?: {
    url?: string;
    key?: string;
    method?: string;
  };
}

interface UploadParamsInput {
  file: File;
  setLayerFile: (key: string, name: string) => void;
  apiToken?: string;
}

const getLayerUploadParams = async ({ file, setLayerFile, apiToken }: UploadParamsInput) => {
  const headers: Record<string, string> = {
    Accept: 'application/json',
  };

  if (apiToken) {
    headers['X-ApiToken'] = apiToken;
  }

  const response = await fetch('/api/v2/file/upload_url.json', {
    credentials: 'include',
    headers,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch upload URL (status ${response.status})`);
  }

  const body = await response.json() as UploadApiResponse;
  const uploadFile = body.file;

  if (!uploadFile?.url || !uploadFile?.key || !uploadFile?.method) {
    throw new Error('Upload URL response is missing required file fields');
  }

  setLayerFile(uploadFile.key, file.name);

  return {
    method: uploadFile.method,
    body: file,
    url: uploadFile.url,
  };
};

export default getLayerUploadParams;
